import { CInputGroup, CLabel } from '@coreui/react';
import * as React from 'react';
import { KComplements, KControlAddon } from '../';
import { ControlTypeEnum, IDispatcher, IGenericListItem, IGetDynListParams } from '../../abstraction';
import { Utils } from '../../core/utils';
import { ControlZoneEnum } from '../../models/ControlZoneEnum';
import { ControlModel } from '../../models/index';
import { KSelect } from './';

interface IProps {
	control: ControlModel;
	onChange?: (value: string) => void;
	onItemSelected ?: (control: ControlModel, value: string) => void;
	getViewstate?: () => IGetDynListParams;
	onShortCutClick?: (actionName: string) => void;
	dispatcher: IDispatcher;
}

interface IState {
	currentControl: ControlModel
}

// Représente une zone de saisie type liste de choix
export class KControlSelect extends React.Component<IProps, IState> {

	inputRef: any;

	public constructor(props: any) {
		super(props);

		this.state = {
			currentControl: this.props.control
		}

		this.inputRef = React.createRef();
	}

	//#region Hacks React

	componentDidUpdate = () => {
		if (this.state.currentControl.HasFocus) {
			if (this.inputRef.current) this.inputRef.current.focus();
		}
	}

	//#endregion Local Events

	//#region Local Events

	// Dans le cas où on a le droit de saisir manuellement une valeur, on gère la valeur
	onChange = (event) => {
		if (this.props.control.Disable) return;
		if (this.props.control.ControlType == ControlTypeEnum.select) return;

		let value: string = event.target.value;
		this.props.control.Value = value;
		this.setState({ currentControl: this.state.currentControl })
		if (this.props.onChange) this.props.onChange(value);
	}

	// Sélection d'un élément dans la liste
	// On affecte la valeur à la zone.
	onItemSelected = (row: IGenericListItem) => {
		this.state.currentControl.Value = row.Key;
		this.state.currentControl.Complement1 = row.Value;
		this.forceUpdate();
		if (this.props.onItemSelected) this.props.onItemSelected(this.state.currentControl, row.Value);
	}

	// Clic sur le control
	// Le contrôle est découpé en 3 zones (LEFT/MIDDLE/RIGHT)
	// Les zones left & right peuvent contenir des addon (bouton images)
	// TODO: A mutualiser - Utilisé dans pas mal de controles
	onControlClick = (zone: ControlZoneEnum) => {
		let ctrl = this.state.currentControl;

		// On regarde pour chacune des zone si une Action est définie
		// Si oui, on simule un clic sur l'un des boutons actions de l'écran

		if (zone == ControlZoneEnum.left && ctrl.RunActionLeft) {
			if (this.props.onShortCutClick) this.props.onShortCutClick(ctrl.RunActionLeft);
		}
		else if (zone == ControlZoneEnum.middle && ctrl.RunActionMiddle) {
			if (this.props.onShortCutClick) this.props.onShortCutClick(ctrl.RunActionMiddle);
		}
		else if (zone == ControlZoneEnum.right && ctrl.RunActionRight) {
			if (this.props.onShortCutClick) this.props.onShortCutClick(ctrl.RunActionRight);
		}
		else {
			// Si rien de tout ça, alors on évalue le script lié au clic passé dans les attributs  (s'il existe)
			// ça permet de prévoir un script côté x3 mais c'est un peu déconseillé quand meme
			try {
				eval(ctrl.OnClick)
			}
			catch (err) {
				console.log(err);
				this.props.dispatcher.MessageBox("Onclick Error in javascript", "Check console for more details", 3);
			}
		}
	}

	//#endregion

	//#region Fonctions métier

	getViewstate = (): IGetDynListParams => {
		if (this.props.getViewstate) return this.props.getViewstate();
		return null;
	};

	//#endregion 

	//#region Rendus
	
	render() {
		let ctrl = this.state.currentControl;
		if (!ctrl) return null;
		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);

		let bssize = Utils.getColSizeClasses(ctrl);

		return (
			<div className={`KControl KControlSelect ${ctrl.Class} ${bssize}`} style={inlineStyle}>
				<CLabel htmlFor={this.props.control.Key}>{ctrl.Description}</CLabel>

				<CInputGroup>
					<KControlAddon imageProvider={this.props.dispatcher} type="prepend" text={ctrl.PrependText} image={ctrl.PrependImage} onClick={() => this.onControlClick(ControlZoneEnum.left)} visibilityCondition={ctrl.PreVisibilityCond} />
					<KSelect dispatcher={this.props.dispatcher} onItemSelected={this.onItemSelected} Control={ctrl} onChange={this.onChange} getViewstate={this.getViewstate} onClick={() => this.onControlClick(ControlZoneEnum.middle)} ></KSelect>
					<KControlAddon imageProvider={this.props.dispatcher} type="append" text={ctrl.AppendText} image={ctrl.AppendImage} onClick={() => this.onControlClick(ControlZoneEnum.right)} visibilityCondition={ctrl.AppVisibilityCond}/>
				</CInputGroup>

				<KComplements Control={ctrl} />
			</div>
		)
	}

	//#endregion
}